/**
 * RN maps `offlineAssignments` as a raw array. Unwrap common envelopes only.
 */
export const toAssignmentList = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.assignments)) return payload.assignments;
  if (Array.isArray(payload.studentAssignments)) return payload.studentAssignments;
  if (Array.isArray(payload.results)) return payload.results;
  if (Array.isArray(payload.items)) return payload.items;
  return [];
};

const assignmentId = (item) => {
  if (!item || typeof item !== 'object') return '';
  return String(item._id || item.id || '');
};

/**
 * Merge online + offline rows. Later lists overwrite earlier ones with the same id
 * so offline PDF metadata wins when both endpoints return the same assignment.
 */
export const mergeAssignmentLists = (...payloads) => {
  const merged = new Map();
  payloads.forEach((payload) => {
    toAssignmentList(payload).forEach((item, index) => {
      if (!item || typeof item !== 'object') return;
      const id = assignmentId(item) || `anon-${payloads.length}-${index}`;
      const existing = merged.get(id);
      if (!existing) {
        merged.set(id, item);
        return;
      }
      const incomingOffline =
        item.source === 'offline' || item.evaluatedPdfUrl || item.marksheetData?.pdfKey;
      merged.set(id, incomingOffline ? { ...existing, ...item, source: 'offline' } : existing);
    });
  });
  return Array.from(merged.values());
};
